import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  CardContent,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
} from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";
import CoreSelect from "../../../../app/core/components/CoreSelect/CoreSelect";
import {
  arePasswordsEqual,
  isEmailValid,
} from "../../../../utils/functions/form";
import {
  doAdminRegistration,
  doUserRegistration,
} from "../registrationActions";
import FormAssoCaaf from "./FormAssoCaaf";
import FormGeneric from "./FormGeneric";

const RegistrationForm = () => {
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const appConfig = useSelector((state) => state.app.appConfig);
  const registration = appConfig?.modules?.registration?.admin;

  const selectList = {
    admin: t("Admin"),
    user: t("User"),
  };

  const [formData, setFormData] = useState({
    role: registration ? "" : selectList.user,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [termini, setTermini] = useState(false);
  const [consenso, setConsenso] = useState(false);
  const [autoDati, setAutoDati] = useState(false);
  const [showConsentAbsenceModal, setShowConsentAbsenceModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [person, setPerson] = useState(true);

  const isDisabled = termini && privacy;
  const isDisabledAsCaaf = termini && privacy && consenso;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownConfirmPassword = (event) => {
    event.preventDefault();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setValidationErrors((prevState) => ({ ...prevState, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidationErrors({});
    const errors = {};
    if (!formData.name?.trim()) {
      errors.name = t("FieldRequired");
    }
    if (!formData.surname?.trim() && person) {
      errors.surname = t("FieldRequired");
    }
    if (!formData.pIva?.trim() && !person) {
      errors.pIva = t("FieldRequired");
    }
    if (!isEmailValid(formData.email)) {
      errors.email = t("FieldRequired");
    }
    if (!formData.role && registration) {
      errors.role = "Seleziona un Ruolo";
    }
    if (!formData.password?.trim()) {
      errors.password = "Inserisci una password";
    }
    if (!formData.confirmPassword?.trim()) {
      errors.confirmPassword = "Reinserisci la password";
    } else if (
      !arePasswordsEqual(formData.password, formData.confirmPassword)
    ) {
      errors.password = "Le password non sono uguali!";
      errors.confirmPassword = "Le password non sono uguali!";
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    if (
      appConfig?.environment === "AISTUDIO" &&
      !consenso &&
      formData.role === selectList.user
    )
      return setShowConsentAbsenceModal(true);

    const userData = {
      name: formData.name,
      surname: formData.surname,
      email: formData.email,
      password: formData.password,
      privacy: true,
      gdpr: true,
      thirdParty: appConfig?.environment === "ASSOCAAF" ? autoDati : true,
      isCompany: !person,
    };

    if (!person) {
      userData.company = {
        name: formData.name,
        vat: formData.pIva,
        email: formData.email,
      };
    }

    const adminData = {
      Name: formData.name,
      Surname: formData.surname,
      Email: formData.email,
      Password: formData.password,
    };
    if (formData.role === selectList.user) {
      dispatch(doUserRegistration(userData)).then((res) => {
        if (res?.payload?.Result !== 1) {
          toast.error(`Errore: ${res?.payload?.Exception}`);
        } else {
          toast.success(t("RegistrationUser"));
        }
      });
    }

    if (formData.role === selectList.admin) {
      dispatch(doAdminRegistration(adminData)).then((res) => {
        if (res?.payload?.Result !== 1) {
          toast.error(`Errore: ${res?.payload?.Exception}`);
        } else {
          toast.success("RegistrationAdmin");
        }
      });
    }
  };
  const handleChangeRadio = (event) => {
    setConsenso(event.target.value === "true");
  };
  const handleChangeRadioAuto = (event) => {
    setAutoDati(event.target.value === "true");
  };

  const handleChangeRadioPerson = (event) => {
    setPerson(event.target.value === "true");
    setFormData((prev) => ({
      name: "",
      surname: "",
      email: "",
      pIva: "",
      password: "",
      confirmPassword: "",
      role: prev.role,
    }));
  };

  return (
    <CardContent className="py-8 px-24">
      <h2
        style={{ color: primaryColor }}
        className="font-bold text-2xl mb-12 w-full mx-auto text-center"
      >
        {t("RegistrationSentence")}
      </h2>
      <Box component="form" className="flex flex-col">
        <CoreSelect
          name="role"
          disabled={!registration}
          onChange={handleInputChange}
          label={t("Profile")}
          items={selectList}
          error={validationErrors.role}
          helperText={validationErrors.role}
          value={formData.role}
        />

        {appConfig?.modules?.company?.formCreateUser &&
          formData.role === selectList.user && (
            <RadioGroup
              row
              value={person}
              className="flex mt-4"
              onChange={handleChangeRadioPerson}
            >
              <FormControlLabel
                value={true}
                control={<Radio size="small" />}
                label={t("NaturalPerson")}
              />
              <FormControlLabel
                value={false}
                control={<Radio size="small" />}
                label={t("LegalPerson")}
              />
            </RadioGroup>
          )}

        <Box className="flex w-full flex-col items-center space-y-4">
          {person ? (
            <>
              <CoreInputField
                name="name"
                className="w-full"
                required={true}
                value={formData.name}
                onChange={handleInputChange}
                label={t("Name")}
                type="text"
                error={Boolean(validationErrors.name)}
                helperText={validationErrors.name}
              />

              <CoreInputField
                name="surname"
                className="w-full"
                required={true}
                value={formData.surname}
                onChange={handleInputChange}
                label={t("Surname")}
                type="text"
                error={Boolean(validationErrors.surname)}
                helperText={validationErrors.surname}
              />

              <CoreInputField
                name="email"
                className="w-full"
                required={true}
                value={formData.email}
                onChange={handleInputChange}
                label="Email"
                type="email"
                error={Boolean(validationErrors.email)}
                helperText={validationErrors.email}
              />
            </>
          ) : (
            <>
              <CoreInputField
                label={t("CompanyName")}
                type="text"
                name="name"
                className="w-full"
                value={formData.name}
                onChange={handleInputChange}
                required={true}
                error={Boolean(validationErrors.name)}
                helperText={validationErrors.name}
              />

              <CoreInputField
                label={t("VAT")}
                type="text"
                name="pIva"
                className="w-full"
                value={formData.pIva}
                onChange={handleInputChange}
                required={true}
                error={Boolean(validationErrors.pIva)}
                helperText={validationErrors.pIva}
              />

              <CoreInputField
                label="Email"
                type="email"
                name="email"
                className="w-full"
                value={formData.email}
                onChange={handleInputChange}
                required={true}
                error={Boolean(validationErrors.email)}
                helperText={validationErrors.email}
              />
            </>
          )}

          <CoreInputField
            name="password"
            className="w-full"
            error={Boolean(validationErrors.password)}
            helperText={validationErrors.password}
            required={true}
            value={formData.password}
            onChange={handleInputChange}
            type={showPassword ? "text" : "password"}
            label="Password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <CoreInputField
            name="confirmPassword"
            className="w-full"
            error={Boolean(validationErrors.confirmPassword)}
            helperText={validationErrors.confirmPassword}
            required={true}
            value={formData.confirmPassword}
            onChange={handleInputChange}
            type={showConfirmPassword ? "text" : "password"}
            label="Conferma password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle confirm password visibility"
                    onClick={handleClickShowConfirmPassword}
                    onMouseDown={handleMouseDownConfirmPassword}
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {appConfig?.environment === "ASSOCAAF" && formData.role ? (
          <FormAssoCaaf
            termini={termini}
            setTermini={setTermini}
            privacy={privacy}
            setPrivacy={setPrivacy}
            consenso={consenso}
            setConsenso={setConsenso}
            formData={formData}
            selectList={selectList}
            autoDati={autoDati}
            handleChangeRadioAuto={handleChangeRadioAuto}
          />
        ) : (
          <FormGeneric
            termini={termini}
            setTermini={setTermini}
            privacy={privacy}
            setPrivacy={setPrivacy}
            formData={formData}
            selectList={selectList}
            consenso={consenso}
            handleChangeRadio={handleChangeRadio}
          />
        )}

        <Box className="flex w-full justify-between mt-16 mb-2 space-x-2">
          <CoreButton
            className="btn-round-outline w-1/2 "
            testo={t("Back")}
            onClick={() => navigate("/login")}
          />
          <CoreButton
            disabled={
              appConfig?.environment === "ASSOCAAF" &&
              formData.role === selectList.user
                ? !isDisabledAsCaaf
                : !isDisabled
            }
            onClick={handleSubmit}
            className="btn-round w-1/2"
            testo={t("Register")}
          />
        </Box>
      </Box>
      <CoreModal
        disableClose
        width={"600px"}
        state={showConsentAbsenceModal}
        onClose={() => setShowConsentAbsenceModal(false)}
        component={
          <>
            <div className="mt-4 flex items-start gap-2">
              <h3 className="m-0">Ci dispiace</h3>
              <ReportProblemRoundedIcon
                fontSize="medium"
                className="fill-yellow-500"
              />
            </div>
            <p>
              Non sarà possibile terminare la registrazione poiché, in assenza
              di consenso, il titolare del trattamento non potrà fornire i
              servizi connessi all'uso di AI Studio.
            </p>
          </>
        }
      />
    </CardContent>
  );
};

export default RegistrationForm;
